export default "__VITE_ASSET__ad615792__"